import { render, staticRenderFns } from "./SpendingLeadersBar.vue?vue&type=template&id=2b8e5029&scoped=true"
import script from "./SpendingLeadersBar.vue?vue&type=script&lang=js"
export * from "./SpendingLeadersBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e5029",
  null
  
)

export default component.exports